import { render, staticRenderFns } from "./TheOrderConfirmation.vue?vue&type=template&id=d3bec5fc&"
import script from "./TheOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./TheOrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./TheOrderConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports